import { apiClient } from './apiClient';
import { ApiClientType } from './constants';

export const sendSlackNotifications = async (data) => {
  await apiClient({ url: '/testscore/slack/notification', method: 'post', data }, ApiClientType.DATA_INGEST_TOOL);
};
